import { Box, Grid, Collapse, Card } from "@mui/material";

import ActiveFilters from "../../../Components/filters/ActiveFilters";

import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
  fakeCustomers: customerCodes,
}) => {
  // All filters in the order they appear
  const activeFilterDefinitions = [
    // Standard filters - in order
    {
      type: "standard",
      id: "customerNo",
      label: "Customer No",
      value: submittedData.customerNo
        ? customerCodes.find((b) => b.customer_no === submittedData.customerNo)
            ?.customer_no || ""
        : "",
    },
  ];

  return (
    <Grid item xs={12} sx={{ mb: 2 }}>
      <Collapse in={filterOpen}>
        <Card>
          <Box p={4}>
            <FilterItems
              filterData={filterData}
              handleChangeFilter={handleChangeFilter}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
              customerCodes={customerCodes}
            />
          </Box>
        </Card>
      </Collapse>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
      />
    </Grid>
  );
};

export default Filter;
